module.exports = __webpack_public_path__ + "static/mr-press-04-a859f41f719f132804916c92b1a38096.jpg";